// Centralized constants for Asset Management modules

// Program Options - used across all Asset Management components
export const PROGRAM_OPTIONS = [
  { value: 'TBTP', label: 'The Billion Tree Plantation' },
  { value: 'SD', label: 'Sports For Development' },
  { value: 'WM', label: 'Waste Management' },
  { value: 'LL', label: 'Learn Lab' },
  { value: 'RF', label: 'Regen Agriculture' },
  { value: 'YOGA', label: 'Yoga' },
  { value: 'WE', label: 'Women Equity' },
  { value: 'RGSH', label: 'RGS Hockey' },
  { value: 'RGSF', label: 'RGS Football' },
  { value: 'RGST', label: 'RGS Tennis' },
  { value: 'RGSG', label: 'RGS Golf' }
] as const;

// Program values only (for simple dropdowns)
export const PROGRAM_VALUES = PROGRAM_OPTIONS.map(option => option.value);

// Asset Type Options - simplified to Video and Image only
export const ASSET_TYPE_OPTIONS = [
  { value: 'Video', label: 'Video' },
  { value: 'Image', label: 'Image' }
] as const;

// Event Options - common events across programs
export const EVENT_OPTIONS = [
  { value: 'Plant Launch', label: 'Plant Launch' },
  { value: 'Training Session', label: 'Training Session' },
  { value: 'Community Meeting', label: 'Community Meeting' },
  { value: 'Awareness Program', label: 'Awareness Program' },
  { value: 'Impact Documentation', label: 'Impact Documentation' },
  { value: 'Sports Event', label: 'Sports Event' },
  { value: 'Waste Collection', label: 'Waste Collection' },
  { value: 'Yoga Session', label: 'Yoga Session' },
  { value: 'Women Empowerment Workshop', label: 'Women Empowerment Workshop' }
] as const;

// Gallery Type Options - used across Visual Galleries components
export const GALLERY_TYPE_OPTIONS = [
  { value: 'village_gallery', label: 'Village Gallery', description: 'Gallery for a specific village' },
  { value: 'district_gallery', label: 'District Gallery', description: 'Gallery for a district' },
  { value: 'program_gallery', label: 'Program Gallery', description: 'Gallery for a program' },
] as const;

// Type exports for TypeScript
export type ProgramValue = typeof PROGRAM_OPTIONS[number]['value'];
export type AssetTypeValue = typeof ASSET_TYPE_OPTIONS[number]['value'];
export type EventValue = typeof EVENT_OPTIONS[number]['value'];